module.exports = __webpack_public_path__ + "static/riverreflect-566548583f08a5c70ef3f390a0553f2b.svg";